import { PayloadAction } from '@reduxjs/toolkit'

// TODO remove redux toolkit dependency and build action creators ourselves

export default function dispatch<T>({ type, payload }: PayloadAction<T>) {
    const action = new CustomEvent(type, { detail: payload })
    dispatchEvent(action)
    console.debug(`+++++ DISPATCHED ACTION - "${type}" with`, payload)
}
